<!-- eslint-disable vue/valid-template-root -->
<template>
  <div class="fixScreen totemBG">
    <vTimeout
      :segundos="$root.getTimeoutName('EDICAO')"
      @modal-show="mountView = ''"
    />
    <div class="tw-bg-black tw-bg-opacity-10 tw-h-full">
      <vBtnReset />
      <div class="tw-text-center">
        <vLogoDefault />
      </div>
      <div
        id="canvasContain"
        class="tw-text-center tw-object-center tw-relative"
      >
        <div class="tw-inline-block tw-mx-auto tw-mt-1">
          <div :key="index" v-for="(canv, index) in listaReferencias">
            <!-- :class="{
              'tw-p-5 tw-pb-16 tw-bg-white': tipo == 'polaroid',
            }" -->
            <div
              v-show="indexAtualDaFoto == index"
              class="tw-p-0 tw-shadow-md tw-transform tw-relative"
            >
              <!-- ph-no-capture: a foto do cliente não vai para a gravação de
                   sessão do PostHog. -->
              <canvas
                :id="'canvas' + index"
                class="ph-no-capture tw-mx-auto"
              ></canvas>
            </div>
            <!-- <p
              v-if="tipo && tipo === 'normal'"
              class="tw-text-white tw-text-center tw-text-xl tw-w-80 tw-mx-auto tw-mt-2 animate-pulse"
            >
              Não esqueça de ajustar o enquadramento da foto! 😊
            </p> -->
          </div>
        </div>
        <div
          class="tw-flex tw-flex-row tw-justify-center tw-items-center tw-pt-5"
        >
          <div
            class="tw-bg-black tw-bg-opacity-10 tw-p-6 tw-rounded-l-md animate-pulse"
            v-if="showChangeOrientationButton"
          >
            <button
              class="tw-text-4xl tw-rounded-lg tw-font-medium tw-bg-white tw-inline-block tw-mx-auto tw-p-3 tw-w-50 tw-shadow-md animate-pulse"
              @click="changeOrientation()"
            >
              <v-icon class="tw-mr-1" color="#da1884" size="42"
                >mdi-screen-rotation</v-icon
              >
              {{ changeOrientationButtonText }}
            </button>
          </div>

          <!-- class="btnZera" -->
          <div class="tw-absolute tw-right-2">
            <button
              class="tw-text-2xl tw-rounded-lg tw-font-medium tw-bg-white tw-inline-block tw-mx-auto tw-p-3 tw-w-50 tw-shadow-md"
              :disabled="toggleResetOriginal"
              @click="desfazerAlteracoesDoCanvasAtual()"
            >
              <v-icon
                :class="{ 'tw-animate-spin': toggleResetOriginal }"
                class="tw-mr-1"
                style="image-rendering: optimizeQuality"
                color="red"
                size="30"
                >mdi-restart</v-icon
              >
              Desfazer tudo
            </button>
          </div>
          <!--
          class="tw-absolute"
            :style="{ left: '-1rem', transform: 'translate(234%, -123%)' }" 
            <div v-if="tipo && tipo === 'normal'" @click="rotateImagem('right')">
              <button type="button" class="defaultBtn tw-ml-8">
                <v-icon class="tw-ml-1" color="#da1884" size="32"
                >mdi-rotate-right</v-icon
                >
              </button>
            </div>
            -->
        </div>
      </div>

      <div
        id="gallery"
        class="tw-flex tw-my-5 tw-overflow-x-auto tw-bg-opacity-20 tw-p-4 tw-bg-gray-100 scroll-modern"
      >
        <div
          :key="index"
          v-for="(item, index) in listaImagens"
          class="tw-flex-none tw-inline-block tw-break-words tw-ml-4"
        >
          <div
            class="tw-py-5 tw-bg-white tw-rounded-xl tw-bg-opacity-30"
            @click="selecionaCanvas(index)"
          >
            <img
              class="ph-no-capture tw-select-none tw-w-80 tw-h-64 tw-rounded-md tw-bg-cover tw-object-contain"
              :src="item.src"
              draggable="false"
              @contextmenu.prevent
              @dragstart.prevent
            />
          </div>
        </div>
      </div>
      <div id="menuBottom" class="menuBottom">
        <div
          id="openMENU"
          class="tw-py-2"
          style="min-height: 400px"
          v-if="mountView !== ''"
        >
          <div
            class="tw-text-right tw-p-2 tw-absolute tw--mt-10 tw-right-4 tw-bg-black tw-bg-opacity-75 tw-rounded-full"
          >
            <button @click="closeMenu()">
              <v-icon color="white" size="45">mdi-close-circle</v-icon>
            </button>
          </div>
          <vActionsSelectUI
            @discartaSelect="discartaSelect"
            @removerItem="removerItem"
            :objetoSelecionado="getSelectedObject"
          />
          <div v-if="mountView == 'textoEditor'">
            <SimpleKeyboard
              @onCreateText="criarTextoNoCanvasAtual"
              @onChange="onChange"
              :input="inputText"
            />
          </div>
          <div v-if="mountView == 'emoji'" class="tw-p-2 tw-text-center">
            <div class="tw-grid tw-grid-cols-4 tw-items-center tw-mx-5 tw-my-3">
              <div
                class="tw-col-span-1 tw-text-white tw-text-4xl tw-mb-1 tw-text-left"
              >
                Emojis
              </div>
              <div class="tw-col-span-3 tw-mb-2 tw-text-right">
                <button
                  v-if="getSelectedObject && getSelectedObject.tipo == 'emoji'"
                  @click="removerItem('emoji')"
                  class="tw-bg-transparent tw-mr-1 tw-text-white tw-p-3 tw-text-2xl tw-uppercase tw-font-normal tw-inline-grid tw-grid-flow-col tw-items-center tw-rounded-2xl tw-border-2 tw-border-solid tw-border-white"
                >
                  <div class="tw-pr-2">
                    <v-icon size="35" color="white">mdi-delete-circle</v-icon>
                  </div>
                  <div class="tw-text-white">Selecionado</div>
                </button>
                <button
                  @click="removerTodosOsItemsDesseTipo('emoji')"
                  class="tw-bg-transparent tw-text-white tw-p-3 tw-text-2xl tw-uppercase tw-font-normal tw-inline-grid tw-grid-flow-col tw-items-center tw-rounded-2xl tw-border-2 tw-border-solid tw-border-white"
                >
                  <div class="tw-pr-2">
                    <v-icon size="35" color="white">mdi-delete-circle</v-icon>
                  </div>
                  <div class="tw-text-white">Limpar</div>
                </button>
              </div>
            </div>

            <!-- Abas de grupo -->
            <div
              class="tw-flex tw-overflow-x-auto tw-gap-3 tw-pb-2 scroll-modern"
            >
              <button
                v-for="(group, idx) in emojiGroups"
                :key="group.value"
                @click="activeEmojiGroupIndex = idx"
                :class="[
                  'tw-flex-none tw-px-4 tw-py-2 tw-rounded-full tw-text-2xl tw-text-white tw-border-2 tw-border-solid tw-transition-colors',
                  activeEmojiGroupIndex === idx
                    ? 'tw-border-white tw-bg-white tw-bg-opacity-20'
                    : 'tw-border-transparent tw-opacity-60',
                ]"
              >
                {{ group.label }}
              </button>
            </div>

            <!-- Lista do grupo ativo -->
            <div class="tw-overflow-y-auto tw-max-h-72 scroll-modern tw-mt-5">
              <section class="tw-grid tw-grid-cols-4 tw-gap-6 tw-p-2">
                <div
                  v-for="(item, index) in emojiGroups[activeEmojiGroupIndex]
                    .items"
                  :key="item.codes || index"
                  class="tw-text-3xl tw-text-white"
                  @click="criarEmojiNoCanvasAtual(item.char)"
                >
                  {{ item.char }}
                </div>
              </section>
            </div>
          </div>

          <div
            v-if="mountView == 'brilho-contraste'"
            class="tw-h-40 tw-p-4 tw-text-center"
          >
            <div class="tw-text-white tw-text-4xl tw-py-2">Brilho</div>
            <div
              class="tw-py-2 tw-grid tw-grid-cols-5 tw-justify-center tw-items-center"
            >
              <div class="tw-col-span-1">
                <button class="btnPlusMinus" @click="sumOrMinusBrilhance('-')">
                  -
                </button>
              </div>
              <div class="tw-col-span-3">
                <input
                  class="tw-w-2/3 tw-bg-white"
                  id="range"
                  type="range"
                  min="0"
                  max="10"
                  v-model.number="include.brilho"
                />
              </div>
              <div class="tw-col-span-1">
                <button class="btnPlusMinus" @click="sumOrMinusBrilhance('+')">
                  +
                </button>
              </div>
            </div>
            <div class="tw-text-white tw-text-4xl tw-py-2">Contraste</div>
            <div class="tw-py-2 tw-grid tw-grid-cols-5 tw-items-center">
              <div class="tw-col-span-1">
                <button class="btnPlusMinus" @click="sumOrMinusContrast('-')">
                  -
                </button>
              </div>
              <div class="tw-col-span-3">
                <input
                  id="range"
                  class="tw-w-2/3"
                  type="range"
                  min="0"
                  max="10"
                  v-model.number="include.contraste"
                />
              </div>
              <div class="tw-col-span-1">
                <button class="btnPlusMinus" @click="sumOrMinusContrast('+')">
                  +
                </button>
              </div>
            </div>
          </div>
          <div v-if="mountView == 'molduras'">
            <div class="tw-mt-4">
              <div class="tw-pl-5 tw-text-white tw-text-3xl">Molduras</div>
              <div
                v-if="!moldurasCarregadas"
                class="tw-pl-5 tw-pt-4 tw-text-white tw-text-xl"
              >
                Carregando molduras...
              </div>
              <div class="containCards scroll-modern">
                <div
                  class="containCardMoldura"
                  :key="
                    moldura.opcaoPadrao
                      ? 'opcao-padrao'
                      : `moldura-${moldura.id}`
                  "
                  v-for="moldura in cardsMolduraOrdenados"
                >
                  <div
                    v-if="moldura.opcaoPadrao"
                    class="cardMoldura"
                    @click="selecionarMoldura(null, true)"
                  >
                    <div class="p-1">
                      <div
                        class="imagem"
                        :class="{
                          cardMolduraSelected:
                            imgMolduraSelecionada == null ||
                            imgMolduraSelecionada === 'default-polaroid',
                        }"
                      >
                        <img
                          :src="getPolaroidDefault.url"
                          :alt="getPolaroidDefault.descricao"
                          :style="{ height: '100%' }"
                        />
                      </div>
                    </div>
                    <div class="descricao">Sem moldura</div>
                  </div>
                  <div
                    v-else
                    class="cardMoldura"
                    @click="selecionarMoldura(moldura.dados)"
                  >
                    <div class="p-1">
                      <div
                        :id="moldura.id"
                        class="imagem"
                        :class="{
                          cardMolduraSelected:
                            imgMolduraSelecionada == moldura.dados,
                        }"
                      >
                        <img
                          :src="moldura.dados.url"
                          :alt="moldura.dados.descricao"
                          :style="{ height: '100%' }"
                          draggable="false"
                          @contextmenu.prevent
                          @dragstart.prevent
                        />
                      </div>
                    </div>
                    <div class="descricao">{{ moldura.descricao }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="mountView == 'filtros'" class="tw-py-5 tw-px-0">
            <div
              class="tw-pb-4 tw-text-3xl tw-text-center tw-uppercase tw-text-white"
            >
              Filtros
            </div>
            <div
              class="tw-p-8 tw-flex tw-overflow-x-auto scroll-modern"
              style="image-rendering: optimizeQuality"
            >
              <vBtnFiltro
                filter="semfiltro"
                :fotoAtual="getImagemAtual"
                @eventClick="apagarFiltrosExistentes()"
              >
                Sem filtro
              </vBtnFiltro>
              <vBtnFiltro
                :fotoAtual="getImagemAtual"
                filter="Grayscale"
                @eventClick="iniciaFiltro('Grayscale')"
              >
                Grayscale</vBtnFiltro
              >
              <vBtnFiltro
                :fotoAtual="getImagemAtual"
                filter="Sepia"
                @eventClick="iniciaFiltro('Sepia')"
                >Sépia
              </vBtnFiltro>
              <vBtnFiltro
                :fotoAtual="getImagemAtual"
                filter="OldTimes"
                @eventClick="iniciaFiltro('OldTimes')"
                >OldTimes
              </vBtnFiltro>
              <vBtnFiltro
                :fotoAtual="getImagemAtual"
                filter="Noise"
                @eventClick="iniciaFiltro('Noise')"
                >Noise
              </vBtnFiltro>
              <vBtnFiltro
                :fotoAtual="getImagemAtual"
                filter="Vibrance"
                @eventClick="iniciaFiltro('Vibrance')"
                >Vibrance
              </vBtnFiltro>
              <vBtnFiltro
                :fotoAtual="getImagemAtual"
                filter="Convolute"
                @eventClick="iniciaFiltro('Convolute')"
              >
                Convolute</vBtnFiltro
              >

              <vBtnFiltro
                :fotoAtual="getImagemAtual"
                filter="HueRotation"
                @eventClick="iniciaFiltro('HueRotation')"
              >
                Matiz Aleatória</vBtnFiltro
              >
            </div>
          </div>
          <div v-if="mountView == 'cortes'">
            <div
              class="tw-p-4 tw-text-3xl tw-text-center tw-uppercase tw-text-white"
            >
              Cortar
            </div>
            <div class="tw-p-2 tw-text-center">
              <div>
                <button
                  class="tw-uppercase tw-text-3xl tw-bg-white tw-p-4 tw-rounded-xl tw-w-2/4"
                  @click="cropper()"
                  v-if="cropToggle"
                >
                  Finalizar
                </button>
              </div>
              <div>
                <button
                  class="tw-uppercase tw-text-3xl tw-mt-3 tw-bg-white tw-p-4 tw-rounded-xl tw-w-2/4"
                  @click="cancelarCropper()"
                  v-if="cropToggle"
                >
                  Cancelar
                </button>
              </div>
              <button
                class="tw-uppercase tw-text-3xl tw-bg-white tw-p-4 tw-rounded-xl tw-w-2/4"
                @click="initCropper()"
                v-if="!cropToggle"
              >
                Iniciar corte
              </button>
            </div>
          </div>
          <div v-if="mountView == 'objetos'"></div>
          <div v-if="mountView == 'girar-imagem'">
            <div id="flipMenu">
              <div
                class="tw-p-4 tw--mt-10 tw-mb-10 tw-text-3xl tw-text-center tw-uppercase tw-text-white"
              >
                Posições
              </div>
              <div class="tw-grid tw-grid-cols-2">
                <div class="tw-text-center tw-justify-center tw-items-center">
                  <div
                    class="tw-text-center tw-text-white tw-uppercase tw-mb-10 tw-text-2xl"
                  >
                    Virar foto
                  </div>
                  <div class="tw-mb-10">
                    <button
                      class="tw-bg-white tw-text-xl tw-w-2/3 tw-p-5 tw-rounded-xl"
                      @click="flipImagem('horizontal')"
                    >
                      Horizontal
                    </button>
                  </div>
                  <div>
                    <button
                      class="tw-bg-white tw-text-xl tw-w-2/3 tw-p-5 tw-rounded-xl"
                      @click="flipImagem('vertical')"
                    >
                      Vertical
                    </button>
                  </div>
                </div>
                <div id="menuGirar" class="tw-pr-8">
                  <div
                    class="tw-text-center tw-uppercase tw-text-2xl tw-text-white tw-mb-5"
                  >
                    Girar Foto
                  </div>
                  <div
                    class="rotate-photo-grid-container tw-grid tw-grid-cols-2 tw-grid-rows-1 tw-gap-8 tw-text-center tw-justify-center tw-items-stretch"
                  >
                    <div class="tw-col-span-1">
                      <button
                        class="tw-bg-white tw-rounded-xl tw-p-5 tw-w-full tw-h-full"
                        @click="rotateImagem('left')"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="tw-h-8 tw-w-8 tw-mx-auto"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                          />
                        </svg>
                        <div class="tw-text-xl">Para esquerda</div>
                      </button>
                    </div>
                    <div class="tw-col-span-1">
                      <button
                        class="tw-bg-white tw-rounded-xl tw-p-5 tw-w-full tw-h-full"
                        @click="rotateImagem('right')"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="tw-h-8 tw-w-8 tw-mx-auto"
                          style="transform: scaleX(-1)"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                          />
                        </svg>
                        <div class="tw-text-xl">Para direita</div>
                      </button>
                    </div>
                    <div class="tw-text-center">
                      <button
                        class="tw-text-2xl tw-rounded-xl tw-h-full tw-bg-white tw-inline-block tw-w-full tw-mx-auto tw-p-4"
                        @click="centralizarImagem()"
                      >
                        Centralizar
                      </button>
                    </div>
                  </div>
                  <div class="tw-grid tw-grid-cols-2 tw-gap-12 tw-px-8"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="bottomMenu"
          :class="`tw-mt-0 tw-overflow-x-auto tw-p-2 tw-bg-black tw-bg-opacity-20 scroll-modern tw-bottom-0 tw-relative tw-grid tw-grid-cols-4 tw-gap-x-1`"
          :style="{ 'grid-template-rows': '75px 75px' }"
        >
          <div
            class="tw-cursor-pointer tw-text-center tw-object-center tw-text-white tw-max-w-[80px] tw-rounded-xl tw-flex tw-justify-center tw-items-center tw-flex-col"
            :key="index"
            v-for="(item, index) in getItemsMenu"
            @click="SelectMenuItem(item)"
            :class="{
              'tw-bg-white tw-bg-opacity-10 tw-rounded-xl':
                mountView == item.mount,
              bgCustom: item.mount == 'confirm',
            }"
          >
            <div>
              <v-icon size="25" color="white">{{ item.icon }}</v-icon>
            </div>
            <div class="tw-text-center tw-font-normal tw-uppercase tw-text-xl">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <vLoadingInterface v-if="modalInterfaceLoading" />
    <div>
      <vFullModal v-if="mountView == 'confirm'">
        <template v-slot:header>
          <div>
            <div class="tw-text-5xl tw-font-bold">Já terminou de editar ?</div>
            <div class="tw-text-4xl tw-mt-10 tw-w-4/5 tw-mx-auto">
              Ao concluir, você não poderá editar novamente as imagens.
            </div>
            <div class="tw-text-4xl tw-mt-10">
              <span v-if="isSkipPaymentStep">Deseja ir para impressão?</span>
              <span v-else>Deseja ir para o pagamento?</span>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <div>
            <div class="tw-mt-28 tw-mx-20 tw-text-4xl">
              <button
                class="tw-uppercase tw-rounded-xl tw-border-4 tw-p-5 tw-w-full tw-border-white tw-border-solid"
                @click="abrirPreviewFinal()"
                :disabled="loadingFinalizar"
              >
                <div v-if="loadingFinalizar" class="tw-text-center">
                  <v-icon size="50" color="white" class="tw-animate-spin"
                    >mdi-loading</v-icon
                  >
                </div>
                <div v-else>
                  <span>VER PRÉVIA FINAL</span>
                </div>
              </button>
            </div>
            <div class="tw-mt-20 tw-mx-20 tw-text-4xl">
              <button
                class="tw-uppercase tw-rounded-xl tw-border-4 tw-p-5 tw-w-full tw-border-white tw-border-solid"
                @click="mountView = ''"
                :disabled="loadingFinalizar"
              >
                <div v-if="loadingFinalizar" class="tw-text-center">
                  <v-icon size="50" color="white" class="tw-animate-spin"
                    >mdi-loading</v-icon
                  >
                </div>
                <div v-else>Não, continuar editando</div>
              </button>
            </div>
          </div>
        </template>
      </vFullModal>

      <vPreview
        :visible="mountView == 'preview-final'"
        :erroPreviewFinal="erroPreviewFinal"
        :listaPreviewsFinais="listaPreviewsFinais"
        :tipo="tipo"
        :loadingFinalizar="loadingFinalizar"
        :isSkipPaymentStep="isSkipPaymentStep"
        :mostrarReiniciar="falhasMemoria >= 3"
        @corrigir-foto="corrigirFotoDoPreview"
        @reiniciar="reiniciarTotem"
        @confirmar="processoFinalizar"
        @tentar-novamente="abrirPreviewFinal"
        @voltar-edicao="mountView = ''"
      />
    </div>

    <!-- Popup de Confirmação -->
    <PopupConfirmacao
      v-if="mostrarPopup"
      @close="onPopupClose"
      @confirmado="onPopupConfirmado"
    />

    <!-- Popup de Instruções: só abre com as fotos já no canvas (ver
         carregarFotos). -->
    <PopupInstrucoes
      v-if="mostrarPopupInstrucoes"
      :tipoFoto="tipo"
      @close="onPopupInstrucoesClose"
    />

    <!-- Modal de Erro -->
    <vFullModal v-if="modalErro.visible">
      <template v-slot:header>
        <div>
          <div class="tw-text-5xl tw-font-bold">Atenção</div>
          <div class="tw-text-4xl tw-mt-10 tw-w-4/5 tw-mx-auto">
            {{ modalErro.mensagem }}
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="tw-mt-20 tw-mx-20 tw-text-4xl">
          <button
            class="tw-uppercase tw-rounded-xl tw-border-4 tw-p-5 tw-w-full tw-border-white tw-border-solid"
            @click="fecharModalErro()"
          >
            OK
          </button>
        </div>
      </template>
    </vFullModal>

    <!-- Fotos que não carregaram (contexto "carregamento") ou folhas que não
         subiram para o Storage (contexto "envio") dentro do prazo. Fica acima
         da tela de carregando (vLoadingInterface z-50; este modal z 9999), que
         também é escondida ao abrir. Sem ação em 15s, o totem reinicia
         sozinho. -->
    <vFullModal v-if="erroCarregamento.visible">
      <template v-slot:header>
        <div
          :data-cy="
            erroCarregamento.contexto === 'envio'
              ? 'erro-envio-fotos'
              : 'erro-carregamento-fotos'
          "
        >
          <div class="tw-text-5xl tw-font-bold">
            {{
              erroCarregamento.contexto === "envio"
                ? "Não conseguimos enviar sua foto"
                : "Não conseguimos carregar suas fotos"
            }}
          </div>
          <div class="tw-text-4xl tw-mt-10 tw-w-4/5 tw-mx-auto">
            Verifique a conexão e toque em "Tentar novamente".
          </div>
          <div class="tw-text-3xl tw-mt-10" data-cy="contador-reinicio">
            O totem será reiniciado em {{ erroCarregamento.segundos }}s
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div
          class="tw-mt-20 tw-mx-20 tw-text-4xl tw-grid tw-grid-cols-2 tw-gap-8"
        >
          <button
            class="tw-uppercase tw-rounded-xl tw-border-4 tw-p-5 tw-w-full tw-border-white tw-border-solid"
            data-cy="tentar-carregar-novamente"
            @click="tentarCarregarNovamente()"
          >
            Tentar novamente
          </button>
          <button
            class="tw-uppercase tw-rounded-xl tw-border-4 tw-p-5 tw-w-full tw-border-white tw-border-solid"
            data-cy="reiniciar-apos-erro"
            @click="reiniciarAposErroCarregamento('botao')"
          >
            Reiniciar
          </button>
        </div>
      </template>
    </vFullModal>
  </div>
</template>

<script>
import { buildMolduraUsageManifest } from "@/service/molduraUsageManifest";
import { reserveQuotaBeforePayment } from "@/service/eventPhotoQuota";
import { ehEvento } from "@/constants/types/tipoTotem";
import { prepararUsoMolduras } from "@/service/molduraUsageTelemetry";
import vBtnFiltro from "@/components/btnFiltro";
import PopupConfirmacao from "@/components/PopupConfirmacao.vue";
import PopupInstrucoes from "@/components/PopupInstrucoes.vue";
import vFullModal from "@/components/vModalFullScreen.vue";
import { tiposDeFotos } from "@/constants/tipoFoto.js";
import {
  filtrarMoldurasIgnoradas,
  getFotosByCompraId,
  getMoldurasByTipo,
  getMoldurasEventoByTipo,
  resolveMolduraStorageUrl,
  resolveStorageUrls,
} from "@/service/editorService";
import {
  preloadEditorFonts,
  renderMoldura,
  useCanvasEditor,
  waitForFontReady,
} from "@/composables/useCanvasEditor";
import {
  ErroComposicaoFolha,
  ErroEnvioFolha,
  FALHAS_FOLHA,
  useExport,
} from "@/composables/useExport";
import { montarFalhaFoto, registrarFalhaFoto } from "@/service/falhasFoto";
import { carregarFotosComPrazo } from "@/utils/carregarFotosComPrazo";
import { mapComConcorrencia } from "@/utils/mapComConcorrencia";

// Segundos do modal de erro de carregamento até o totem reiniciar sozinho.
const SEGUNDOS_PARA_REINICIAR = 15;
// URLs de moldura pedidas ao Storage ao mesmo tempo. Uma por vez, ~120
// molduras levavam dezenas de segundos na internet do totem.
const CONCORRENCIA_URLS_MOLDURA = 8;
import { useFilters } from "@/composables/useFilters";
import { createFormat } from "@/formats/index";
import { polaroidDefaultMoldura } from "@/constants/configEditor";
import {
  moldurasEventoValidas,
  moldurasVisiveis,
} from "@/service/eventFramePolicy";
import { RestartTotem } from "@/utils/utilsTotem";
import { pulaEtapaPagamento } from "@/utils/cobrancaTotem";
import { fabric } from "fabric";
import emojis from "emoji.json/emoji-compact.json";
import Activities from "../../../assets/emojis/Activities.json";
import AnimalNature from "../../../assets/emojis/Animals & Nature.json";
import Flags from "../../../assets/emojis/Flags.json";
import FoodDrink from "../../../assets/emojis/Food & Drink.json";
import Objects from "../../../assets/emojis/Objects.json";
import SmileysEmotions from "../../../assets/emojis/Smileys & Emotion.json";
import Symbols from "../../../assets/emojis/Symbols.json";
import TravelPlaces from "../../../assets/emojis/Travel & Places.json";
import vActionsSelectUI from "./ActionsSelectUI.vue";
import vPreview from "./vPreview.vue";
import SimpleKeyboard from "./keyboard.vue";
import vLoadingInterface from "./vLoadingInterface";
import posthog from "@/posthog";

export default {
  components: {
    vActionsSelectUI,
    vLoadingInterface,
    vBtnFiltro,
    vFullModal,
    PopupConfirmacao,
    PopupInstrucoes,
    SimpleKeyboard,
    vPreview,
  },
  data() {
    return {
      previewScale: 0.5,
      listaMolduras: [],
      // Molduras do evento (o que o canvas espera para montar).
      moldurasReadyPromise: null,
      // Lista de cards completa (evento + globais quando valem).
      moldurasCarregadas: false,
      moldurasErro: false,
      moldurasGlobaisErro: false,
      moldurasGlobaisCarregadas: false,
      leituraMoldurasGlobais: null,
      moldurasEventoSnapshot: null,
      molduraEventoEscolhidaPorFoto: {},
      numeroDeRenderesFinalizados: 0,
      loadingFinalizar: false,
      mostrarPopup: false,
      mostrarPopupInstrucoes: false,
      toggleResetOriginal: false,
      listaEmoji: [],
      listaPreviewsFinais: [],
      erroPreviewFinal: "",
      imgMolduraSelecionada: null,
      molduraSelecaoVersao: 0,
      changedOrientation: {},
      menuList: [
        { name: "Finalizar", mount: "confirm", icon: "mdi-check-all" },
        { name: "Emojis", mount: "emoji", icon: "mdi-emoticon" },
        { name: "Texto", mount: "textoEditor", icon: "mdi-pencil" },
        {
          name: "Molduras",
          mount: "molduras",
          icon: "mdi-panorama-variant-outline",
        },
        { name: "Posições", mount: "girar-imagem", icon: "mdi-rotate-right" },
      ],
      modalInterfaceLoading: true,
      canvas: [],
      listaImagens: [],
      listaReferencias: [],
      itemSelecionado: "",
      indexAtualDaFoto: 0,
      tipo: "polaroid",
      mountView: "",
      contadorUpload: 0,
      contadorUploadMax: 0,
      include: { brilho: 0, contraste: 0 },
      includeOutput: { brilho: 0, contraste: 0 },
      cropRect: "",
      cropToggle: false,
      inputText: "",
      activeEmojiGroupIndex: 0,
      emojiGroups: [
        {
          value: "Smileys & Emotion",
          label: "Smileys e Pessoas",
          items: SmileysEmotions,
        },
        {
          value: "Animals & Nature",
          label: "Animais e Natureza",
          items: AnimalNature,
        },
        { value: "Food & Drink", label: "Comida e Bebida", items: FoodDrink },
        {
          value: "Travel & Places",
          label: "Viagem e Locais",
          items: TravelPlaces,
        },
        { value: "Activities", label: "Atividades", items: Activities },
        { value: "Objects", label: "Objetos", items: Objects },
        { value: "Symbols", label: "Símbolos", items: Symbols },
        { value: "Flags", label: "Bandeiras", items: Flags },
      ],
      stopChangedOrientation: false,
      destruido: false,
      modalErro: { visible: false, mensagem: "", reiniciar: false },
      // Falhas seguidas de memória ao montar a folha. A partir de 3, a prévia
      // oferece reiniciar o totem (só recarregar libera a memória).
      falhasMemoria: 0,
      // Modal de erro com contagem para reiniciar. `contexto`: "carregamento"
      // (fotos não baixaram) ou "envio" (folhas não subiram).
      erroCarregamento: {
        visible: false,
        segundos: SEGUNDOS_PARA_REINICIAR,
        contexto: "carregamento",
      },
      // Fotos já colocadas no canvas: "Tentar novamente" só baixa as outras.
      fotosNoCanvas: {},
      fotosOriginaisNoCanvas: {},
      // instâncias dos composables (inicializados em initMountInterface)
      canvasEditorInst: null,
      filtersInst: null,
      exportInst: null,
    };
  },
  watch: {
    "include.brilho": function () {
      this.filtersInst.calcBrilho();
      this.includeOutput.brilho = this.filtersInst.includeOutput.brilho;
      this.iniciaFiltro("Brightness", true);
    },
    "include.contraste": function () {
      this.filtersInst.calcContraste();
      this.includeOutput.contraste = this.filtersInst.includeOutput.contraste;
      this.iniciaFiltro("Contrast", true);
    },
    changedOrientation() {
      if (!this.stopChangedOrientation) {
        this.ajustarCanvasDaFoto(this.indexAtualDaFoto);
        this.centralizarImagem();
      }
    },
  },
  computed: {
    formato() {
      return createFormat(this.tipo, {
        previewScale: this.previewScale,
        molduraFixa: this.moldurasEventoDe(this.getOrientationID)[0] || null,
      });
    },
    canvasSize() {
      return this.formato.canvasSize;
    },
    getPolaroidDefault() {
      return polaroidDefaultMoldura;
    },
    getOrientationID() {
      return this.orientacaoDaFoto(this.indexAtualDaFoto);
    },
    // Molduras fixas do evento que valem para o tipo de foto desta compra, nas
    // duas orientações.
    moldurasEvento() {
      return moldurasEventoValidas(this.listaMolduras, this.tipo).map(
        (item) => ({
          id: item.id,
          nome: item.dados.descricao,
          tipo: item.dados.tipo,
          url: item.dados.url,
          orientacao: item.dados.orientacao,
        })
      );
    },
    // Com moldura fixa a moldura deixa de ser opcional: a lista exibida é só a
    // do evento, uma delas já entra aplicada e não existe card "Sem moldura".
    molduraFixaAtiva() {
      return this.moldurasEvento.length > 0;
    },
    // Molduras do evento da orientação da foto atual — como nas molduras
    // globais, retrato e paisagem não se misturam. Mesmo formato de card das
    // globais ({ id, dados }). Computed (e não método) para as referências não
    // mudarem a cada render — é por identidade que o card marca qual moldura
    // está selecionada.
    cardsMolduraEvento() {
      return moldurasVisiveis(
        this.listaMolduras,
        this.tipo,
        this.getOrientationID
      ).filter((item) => item.dados.evento);
    },
    getMolduras() {
      if (!this.moldurasCarregadas) return [];
      return moldurasVisiveis(
        this.listaMolduras,
        this.tipo,
        this.getOrientationID
      );
    },
    cardsMolduraOrdenados() {
      const molduras = this.getMolduras;
      if (
        this.tipo !== "polaroid" ||
        !this.moldurasCarregadas ||
        this.moldurasErro ||
        this.molduraEventoObrigatoria
      ) {
        return molduras;
      }

      const primeiraComum = molduras.findIndex(
        (moldura) => moldura.dados.destaque !== true
      );
      const posicaoPadrao =
        primeiraComum === -1 ? molduras.length : primeiraComum;
      return [
        ...molduras.slice(0, posicaoPadrao),
        { opcaoPadrao: true },
        ...molduras.slice(posicaoPadrao),
      ];
    },
    molduraEventoObrigatoria() {
      return moldurasEventoValidas(this.listaMolduras, this.tipo).length > 0;
    },
    // Decide o texto do botão de finalizar ("CONFIRMAR E IMPRIMIR" em vez de
    // seguir para o pagamento). Tem de concordar com o roteador de etapas do
    // main.js, senão o cliente lê "ir para pagamento" e cai na impressão.
    isSkipPaymentStep() {
      const compra = this.$store.getters["compra/getCompra"];
      if (compra.valor === 0) return true;
      return pulaEtapaPagamento(this.$store.getters["totem/getTotem"]);
    },
    showChangeOrientationButton() {
      if (!this.formato.supportsOrientation) return false;
      // Com moldura fixa a foto não sai sem moldura: só dá para girar se o
      // evento cadastrou moldura para a outra orientação.
      if (!this.molduraFixaAtiva) return true;
      return this.moldurasEventoDe(this.outraOrientacao()).length > 0;
    },
    changeOrientationButtonText() {
      const landscape = "Paisagem";
      const portrait = "Retrato";
      const original = this.tipo === tiposDeFotos.NORMAL ? landscape : portrait;
      const flipped = this.tipo === tiposDeFotos.NORMAL ? portrait : landscape;
      return this.changedOrientation[this.indexAtualDaFoto]
        ? flipped
        : original;
    },
    getItemsMenu() {
      // 3x4 e passaporte são fotos de documento: sem menu Molduras.
      if (this.formatoTemMolduras()) return this.menuList;
      return this.menuList.filter((item) => item.mount !== "molduras");
    },
    getSelectedObject() {
      if (this.itemSelecionado && this.itemSelecionado.toObject) {
        return this.itemSelecionado.toObject();
      }
      return this.itemSelecionado;
    },
    getImagemAtual() {
      return this.listaImagens[this.indexAtualDaFoto] || {};
    },
    getCompra() {
      return this.$store.getters["compra/getCompra"];
    },
  },
  beforeMount() {
    this.initMountInterface();
  },
  mounted() {
    this.listaEmoji = emojis;
    preloadEditorFonts();
  },
  beforeDestroy() {
    // O carregamento ou o envio podem desistir depois que o editor fechou: o
    // modal com a contagem para reiniciar não pode abrir na tela seguinte.
    this.destruido = true;
    this.pararContadorReinicio();
    if (this.canvasEditorInst) {
      this.canvasEditorInst.destruirInstancias(this.listaReferencias);
    }
  },
  methods: {
    // ── Canvas helpers ─────────────────────────────────────────────────────────
    getCanvas() {
      return this.canvas[this.indexAtualDaFoto].instancia;
    },
    typeIsOrientation() {
      return this.formato.supportsOrientation;
    },

    // ── Orientação ─────────────────────────────────────────────────────────────
    orientacaoDaFoto(index) {
      return this.changedOrientation[index] ? "PAISAGEM" : "RETRATO";
    },
    outraOrientacao() {
      return this.getOrientationID === "PAISAGEM" ? "RETRATO" : "PAISAGEM";
    },
    moldurasEventoDe(orientacao) {
      return this.moldurasEvento.filter(
        (moldura) => moldura.orientacao === orientacao
      );
    },
    // Moldura que entra aplicada junto com a foto (na montagem e no "desfazer").
    // No evento é a primeira da orientação daquela foto.
    molduraPadraoDaFoto(index) {
      if (!this.molduraFixaAtiva) return this.formato.defaultMoldura;
      return this.moldurasEventoDe(this.orientacaoDaFoto(index))[0] || null;
    },
    // Retrato usa o tamanho do formato; paisagem, o mesmo tamanho deitado.
    ajustarCanvasDaFoto(index) {
      const { width, height } = this.canvasSize;
      const canvas = this.canvas[index].instancia;
      const paisagem = this.changedOrientation[index];
      canvas.setWidth(paisagem ? height : width);
      canvas.setHeight(paisagem ? width : height);
    },
    changeOrientation() {
      if (!this.formato.supportsOrientation) return;
      const proximaOrientacao = this.changedOrientation[this.indexAtualDaFoto]
        ? "RETRATO"
        : "PAISAGEM";
      if (
        moldurasEventoValidas(this.listaMolduras, this.tipo).length > 0 &&
        !moldurasVisiveis(this.listaMolduras, this.tipo, proximaOrientacao)
          .length
      ) {
        this.mostrarErro("Não há moldura do evento para esta orientação.");
        return;
      }
      // Com moldura fixa a foto não pode ficar sem moldura: ao girar entra a
      // moldura do evento da nova orientação — a de mesmo nome da que estava
      // aplicada, quando o evento cadastrou o par retrato/paisagem.
      const molduraAnterior = this.molduraFixaAtiva
        ? this.molduraEventoDoCanvasAtual()
        : null;
      this.canvasEditorInst.validaExistenciaDeMoldura(this.indexAtualDaFoto);
      this.changedOrientation = {
        ...this.changedOrientation,
        [this.indexAtualDaFoto]:
          !this.changedOrientation[this.indexAtualDaFoto],
      };
      this.molduraEventoEscolhidaPorFoto = {
        ...this.molduraEventoEscolhidaPorFoto,
        [this.indexAtualDaFoto]: null,
      };
      this.$nextTick(() =>
        this.aplicarMolduraObrigatoria(this.indexAtualDaFoto)
      );
      if (
        !this.changedOrientation[this.indexAtualDaFoto] &&
        this.mountView == "molduras"
      ) {
        this.mountView = "";
      }
      if (this.molduraFixaAtiva) {
        // getOrientationID já é a orientação nova: os cards são os dela.
        const card =
          this.cardsMolduraEvento.find(
            (item) => molduraAnterior && item.descricao === molduraAnterior.nome
          ) || this.cardsMolduraEvento[0];
        this.imgMolduraSelecionada = card.dados;
        this.molduraEventoEscolhidaPorFoto = {
          ...this.molduraEventoEscolhidaPorFoto,
          [this.indexAtualDaFoto]: card.dados.eventoId,
        };
        // O watcher de changedOrientation redimensiona o canvas antes deste
        // callback; a moldura precisa ser aplicada já no tamanho novo.
        this.$nextTick(() =>
          renderMoldura(this.getCanvas(), card.dados.url, false, card.dados.eventoId)
        );
      }
    },
    molduraEventoDoCanvasAtual() {
      const noCanvas = this.getCanvas()
        .getObjects()
        .find((item) => item.toObject().tipo === "moldura");
      if (!noCanvas) return null;
      const url = noCanvas.getSrc();
      return this.moldurasEvento.find((moldura) => moldura.url === url) || null;
    },

    // ── Molduras ───────────────────────────────────────────────────────────────
    async selecionarMoldura(moldura, isPolaroidDefault) {
      if (!this.moldurasCarregadas || this.moldurasErro) {
        this.mostrarErro(
          "Aguarde o carregamento das molduras e tente novamente."
        );
        return false;
      }
      const obrigatoria =
        moldurasEventoValidas(this.listaMolduras, this.tipo).length > 0;
      if (obrigatoria) {
        const permitidas = moldurasVisiveis(
          this.listaMolduras,
          this.tipo,
          this.getOrientationID
        );
        if (
          isPolaroidDefault ||
          !permitidas.some((item) => item.dados.eventoId === moldura?.eventoId)
        ) {
          this.mostrarErro("Escolha uma moldura válida do evento.");
          return false;
        }
      }
      const item = isPolaroidDefault
        ? { url: this.getPolaroidDefault.url }
        : moldura || {};
      const versao = ++this.molduraSelecaoVersao;
      const indexFoto = this.indexAtualDaFoto;
      const orientacao = this.getOrientationID;
      const molduraUsoId = this.listaMolduras.find((frame) => frame.dados === item)?.id;
      let aplicada;
      try {
        aplicada = await renderMoldura(
          this.getCanvas(),
          item.url,
          false,
          obrigatoria ? item.eventoId : null,
          ...(molduraUsoId ? [molduraUsoId] : [])
        );
      } catch {
        aplicada = false;
      }
      // A cancelled older render must not clear the newer frame selection.
      if (
        versao !== this.molduraSelecaoVersao ||
        indexFoto !== this.indexAtualDaFoto ||
        orientacao !== this.getOrientationID
      ) return false;
      if (aplicada === false) {
        this.imgMolduraSelecionada = null;
        if (!obrigatoria && moldura) {
          this.listaMolduras = this.listaMolduras.filter(
            (frame) => frame.dados !== moldura
          );
        }
        this.mostrarErro(
          obrigatoria
            ? "Não foi possível carregar a moldura do evento. Tente novamente antes de finalizar."
            : "Não foi possível carregar esta moldura. Escolha outra ou continue sem moldura."
        );
        return false;
      }
      if (obrigatoria) {
        this.molduraEventoEscolhidaPorFoto = {
          ...this.molduraEventoEscolhidaPorFoto,
          [indexFoto]: moldura.eventoId,
        };
      }
      this.imgMolduraSelecionada = isPolaroidDefault ? "default-polaroid" : item;
      return aplicada;
    },
    // Leitura completa: as molduras do evento e, se elas não valem para este
    // tipo de foto, as globais.
    async carregaFirestoreMoldura() {
      await this.carregarMoldurasEventoDaCompra();
      await this.carregarMoldurasGlobais();
    },
    // Só o que a montagem do canvas precisa: as molduras obrigatórias do
    // evento decidem a orientação inicial e a moldura que entra aplicada.
    async carregarMoldurasEventoDaCompra() {
      console.log("Carregando molduras, tipo:", this.tipo);
      const totem = this.$store.getters["totem/getTotem"];
      const totemId = totem.id;
      const tipo = this.tipo;
      if (!this.usaMoldurasEvento()) {
        this.moldurasErro = false;
        return;
      }
      // Sem a leitura das exclusivas, não é seguro oferecer a finalização.
      try {
        const exclusivas = await getMoldurasEventoByTipo(totemId, tipo);
        this.registrarMoldurasEvento(exclusivas, totemId, tipo);
      } catch (error) {
        this.moldurasErro = true;
        console.error("Falha ao carregar molduras do evento", error);
        return;
      }
      // Com moldura do evento as globais não aparecem: a lista já está pronta.
      if (this.temMoldurasEventoDoTipo()) this.moldurasCarregadas = true;
    },
    temMoldurasEventoDoTipo() {
      return moldurasEventoValidas(this.listaMolduras, this.tipo).length > 0;
    },
    // Uma leitura por vez: a do início do editor pode estar em andamento
    // quando a revalidação do evento pede de novo.
    carregarMoldurasGlobais() {
      if (!this.leituraMoldurasGlobais) {
        this.leituraMoldurasGlobais = this.buscarMoldurasGlobais().finally(
          () => {
            this.leituraMoldurasGlobais = null;
          }
        );
      }
      return this.leituraMoldurasGlobais;
    },
    // 3x4 e passaporte não usam moldura (ver supportsMolduras nos formatos).
    formatoTemMolduras() {
      try {
        return createFormat(this.tipo).supportsMolduras;
      } catch {
        // Tipo desconhecido: mantém o comportamento de sempre.
        return true;
      }
    },
    async buscarMoldurasGlobais() {
      // Formato sem moldura: nem consulta o Firestore. Evento com moldura fixa
      // neste tipo: as globais nunca viram card (moldurasVisiveis), então
      // também não são buscadas.
      if (
        !this.formatoTemMolduras() ||
        this.temMoldurasEventoDoTipo() ||
        this.moldurasGlobaisCarregadas
      ) {
        this.moldurasCarregadas = true;
        return;
      }
      this.moldurasGlobaisErro = false;
      try {
        const totem = this.$store.getters["totem/getTotem"];
        const tipo = this.tipo;
        const globaisVisiveis = filtrarMoldurasIgnoradas(
          await getMoldurasByTipo(tipo),
          totem.molduraIgnorada
        ).filter((snap) => snap.dados.tipo === tipo);
        // Em paralelo (com limite) e na ordem do catálogo, que decide a ordem
        // dos cards. Uma URL que falha só tira aquela moldura da lista.
        const links = await mapComConcorrencia(
          globaisVisiveis,
          CONCORRENCIA_URLS_MOLDURA,
          (snap) => resolveMolduraStorageUrl(snap)
        );
        const novas = [];
        links.forEach((resultado, index) => {
          if (resultado.erro) {
            console.error("Erro ao resolver URL da moldura", resultado.erro);
            return;
          }
          const snap = globaisVisiveis[index];
          snap.dados.url = resultado.valor;
          novas.push({ ...snap });
        });
        this.listaMolduras = [...this.listaMolduras, ...novas];
        this.moldurasGlobaisCarregadas = true;
      } catch (error) {
        console.error("Falha ao carregar molduras globais", error);
        this.moldurasGlobaisErro = true;
      }
      this.moldurasCarregadas = true;
    },
    usaMoldurasEvento() {
      const totem = this.$store.getters["totem/getTotem"];
      return (
        ["EVENTO", "TOTINHO"].includes(
          String(totem?.tipoTotem || "").toUpperCase()
        ) && [tiposDeFotos.NORMAL, tiposDeFotos.POLAROID].includes(this.tipo)
      );
    },
    registrarMoldurasEvento(molduras, totemId, tipo) {
      const totem = this.$store.getters["totem/getTotem"];
      if (
        !totemId ||
        totem.id !== totemId ||
        this.tipo !== tipo ||
        !Array.isArray(molduras)
      ) {
        throw new Error("A fonte das molduras da compra mudou.");
      }
      this.moldurasEventoSnapshot = {
        totemId,
        tipo,
        molduras: molduras.map((item) => ({
          ...item,
          dados: { ...item.dados },
        })),
      };
      this.listaMolduras = [
        ...this.listaMolduras.filter((item) => !item.dados?.evento),
        ...molduras,
      ];
      this.moldurasErro = false;
    },
    temSnapshotMoldurasEvento() {
      const totem = this.$store.getters["totem/getTotem"];
      const snapshot = this.moldurasEventoSnapshot;
      return (
        !!totem.id &&
        snapshot?.totemId === totem.id &&
        snapshot.tipo === this.tipo &&
        Array.isArray(snapshot.molduras)
      );
    },
    moldurasEventoJaAplicadasValidas() {
      if (
        !this.temSnapshotMoldurasEvento() ||
        !this.listaReferencias.length ||
        this.canvas.length !== this.listaReferencias.length ||
        this.listaImagens.length !== this.listaReferencias.length
      ) {
        return false;
      }
      const validas = moldurasEventoValidas(
        this.moldurasEventoSnapshot.molduras,
        this.tipo
      ).filter((item) => {
        const id = item.dados.eventoId;
        return (
          typeof id === "string" &&
          id.trim().length > 0 &&
          !["undefined", "null"].includes(id) &&
          item.id === id
        );
      });
      if (!validas.length) return false;
      return this.canvas.every((foto, index) => {
        const objetos = foto.instancia?.getObjects?.();
        if (!Array.isArray(objetos)) return false;
        if (!objetos.some((item) => item.toObject?.().tipo === "foto"))
          return false;
        const orientacao = this.orientacaoDaFoto(index);
        return objetos.some(
          (item) =>
            item.toObject?.().tipo === "moldura" &&
            validas.some(
              (moldura) =>
                moldura.dados.orientacao === orientacao &&
                item.eventoMolduraId === moldura.dados.eventoId &&
                item.eventoMolduraUrl === moldura.dados.url &&
                this.molduraEventoEscolhidaPorFoto[index] ===
                  moldura.dados.eventoId
            )
        );
      });
    },
    podeUsarSnapshotMoldurasEvento(error) {
      const codigo = String(error?.code || "").replace(/^firestore\//, "");
      if (!["unavailable", "deadline-exceeded"].includes(codigo)) return false;
      try {
        return this.moldurasEventoJaAplicadasValidas();
      } catch (erroCanvas) {
        console.error("Falha ao conferir moldura já aplicada", erroCanvas);
        return false;
      }
    },
    async aplicarMolduraObrigatoria(index) {
      const exclusivas = moldurasEventoValidas(this.listaMolduras, this.tipo);
      if (!exclusivas.length) {
        if (this.molduraEventoEscolhidaPorFoto[index]) {
          this.molduraEventoEscolhidaPorFoto = {
            ...this.molduraEventoEscolhidaPorFoto,
            [index]: null,
          };
          this.canvasEditorInst.validaExistenciaDeMoldura(index);
          if (this.tipo === tiposDeFotos.POLAROID) {
            await renderMoldura(
              this.canvas[index].instancia,
              this.getPolaroidDefault.url
            );
          }
        }
        return true;
      }
      const orientacao = this.orientacaoDaFoto(index);
      const disponiveis = exclusivas.filter(
        (moldura) => moldura.dados.orientacao === orientacao
      );
      if (!disponiveis.length) return false;
      const escolhida =
        disponiveis.find(
          (moldura) =>
            moldura.dados.eventoId === this.molduraEventoEscolhidaPorFoto[index]
        ) || disponiveis[0];
      const instancia = this.canvas[index]?.instancia;
      if (!instancia) return false;
      this.molduraEventoEscolhidaPorFoto = {
        ...this.molduraEventoEscolhidaPorFoto,
        [index]: escolhida.dados.eventoId,
      };
      if (index === this.indexAtualDaFoto)
        this.imgMolduraSelecionada = escolhida.dados;
      if (
        instancia
          .getObjects()
          .some(
            (item) =>
              item.toObject().tipo === "moldura" &&
              item.eventoMolduraId === escolhida.dados.eventoId &&
              item.eventoMolduraUrl === escolhida.dados.url
          )
      ) {
        return true;
      }
      return renderMoldura(
        instancia,
        escolhida.dados.url,
        false,
        escolhida.dados.eventoId
      );
    },
    async validarMoldurasEventoAtuais() {
      if (this.moldurasReadyPromise) {
        try {
          await this.moldurasReadyPromise;
        } catch (error) {
          console.error("Falha ao aguardar molduras", error);
        }
      }
      const totem = this.$store.getters["totem/getTotem"];
      const totemId = totem.id;
      const tipo = this.tipo;
      if (!this.usaMoldurasEvento()) this.moldurasErro = false;
      if (
        this.usaMoldurasEvento() &&
        (this.moldurasErro ||
          !this.temSnapshotMoldurasEvento() ||
          this.moldurasEventoSnapshot.molduras.length > 0)
      ) {
        try {
          const atuais = await getMoldurasEventoByTipo(totemId, tipo);
          this.registrarMoldurasEvento(atuais, totemId, tipo);
          // O evento tirou as molduras deste tipo no meio da compra: as
          // globais, que não tinham sido buscadas, passam a valer.
          if (!this.temMoldurasEventoDoTipo()) this.carregarMoldurasGlobais();
        } catch (error) {
          console.error("Falha ao revalidar molduras do evento", error);
          if (this.podeUsarSnapshotMoldurasEvento(error)) {
            this.moldurasErro = false;
            return true;
          }
          this.moldurasErro = true;
          this.mostrarErro(
            "Não foi possível verificar as molduras do evento. Tente novamente."
          );
          return false;
        }
      }
      for (let index = 0; index < this.canvas.length; index += 1) {
        try {
          if (await this.aplicarMolduraObrigatoria(index)) continue;
          this.indexAtualDaFoto = index;
          this.mostrarErro(
            "Não há moldura válida para a orientação desta foto. Ajuste-a antes de finalizar."
          );
          return false;
        } catch (error) {
          console.error("Falha ao preparar moldura antes de finalizar", error);
          this.mostrarErro(
            "Não foi possível preparar a moldura. Tente novamente."
          );
          return false;
        }
      }
      return true;
    },

    // ── Menu ───────────────────────────────────────────────────────────────────
    onChange(input) {
      this.inputText = input;
    },
    closeMenu() {
      if (this.cropToggle) this.cancelarCropper();
      this.mountView = "";
    },
    SelectMenuItem(item) {
      if (this.cropToggle) this.cancelarCropper();
      if (item.mount === "confirm") {
        this.abrirPreviewFinal();
      } else {
        this.mountView = item.mount;
      }
    },

    // ── Popups ─────────────────────────────────────────────────────────────────
    onPopupClose() {
      this.mostrarPopup = false;
    },
    onPopupInstrucoesClose() {
      this.mostrarPopupInstrucoes = false;
    },
    onPopupConfirmado() {
      this.mostrarPopup = false;
      this.abrirPreviewFinal();
    },
    mostrarErro(mensagem, reiniciar = false) {
      this.modalErro = { visible: true, mensagem, reiniciar };
    },
    fecharModalErro() {
      const reiniciar = this.modalErro.reiniciar;
      this.modalErro = { visible: false, mensagem: "", reiniciar: false };
      if (reiniciar) RestartTotem();
    },

    // ── Preview final ──────────────────────────────────────────────────────────
    async abrirPreviewFinal() {
      this.loadingFinalizar = true;
      this.erroPreviewFinal = "";
      try {
        if (!(await this.validarMoldurasEventoAtuais())) return;
        const previews = [];
        for (let index = 0; index < this.canvas.length; index += 1) {
          const assinatura = this.exportInst.getCanvasExportSignature(index);
          const {
            imagemDataUrl,
            imagemDataUrlDisplay,
            ultimaAnalise,
            tentativas,
            comProblema,
          } = await this.exportInst.exportCanvasWithValidation(index);

          if (tentativas > 1) {
            console.warn("Retry export da foto para preview", {
              index,
              tentativas,
              analise: ultimaAnalise,
            });
          }

          const orientacao = this.changedOrientation[index]
            ? "PAISAGEM"
            : "RETRATO";
          const preview = {
            index,
            imagemDataUrl,
            imagemDataUrlDisplay,
            assinatura,
            orientacao,
            comProblema,
            // A montagem da folha compara a área da foto com esta análise.
            ultimaAnalise,
          };
          // Passaporte: a prévia mostra a folha com as 4 cópias, que é o que
          // sai na impressora. Na folha a foto retrato fica deitada; para o
          // cliente conferir, a prévia mostra a folha em pé, com a foto na
          // posição em que ele editou.
          if (this.tipo === tiposDeFotos.PASSAPORTE) {
            preview.folhaDataUrl = await this.exportInst.composePassaporteSheet(
              imagemDataUrl,
              ultimaAnalise
            );
            preview.folhaDataUrlDisplay =
              orientacao === "RETRATO"
                ? await this.exportInst.rotateFinalImage(preview.folhaDataUrl)
                : preview.folhaDataUrl;
          }
          previews.push(preview);
        }
        this.listaPreviewsFinais = previews;
        posthog.capture("editor_preview_requested", {
          photo_count: previews.length,
          photo_type: this.tipo,
        });
        this.mountView = "preview-final";
      } catch (error) {
        console.error(error);
        this.erroPreviewFinal =
          "Não foi possível gerar a prévia. Tente novamente.";
      } finally {
        this.loadingFinalizar = false;
      }
    },
    // Montagem ou envio das folhas falhou: nada avança (nem pagamento nem
    // impressão). Volta para a prévia com a mensagem do caso e registra.
    falhaAoFinalizar(error) {
      console.error(error);
      this.loadingFinalizar = false;
      this.modalInterfaceLoading = false;

      const falhaConhecida =
        error instanceof ErroComposicaoFolha || error instanceof ErroEnvioFolha;
      if (falhaConhecida) this.registrarFalhaFolha(error);

      // O envio já tentou por até 120s por folha: modal com "Tentar novamente |
      // Reiniciar" e contagem, como no carregamento das fotos.
      if (error instanceof ErroEnvioFolha) {
        this.mountView = "";
        this.erroPreviewFinal = "";
        this.abrirErroCarregamento("envio");
        return;
      }

      this.mountView = "preview-final";
      if (error && error.tipo === FALHAS_FOLHA.MEMORIA) {
        this.falhasMemoria += 1;
      }

      if (
        error instanceof ErroComposicaoFolha &&
        error.tipo !== FALHAS_FOLHA.MEMORIA
      ) {
        this.erroPreviewFinal =
          'Não conseguimos preparar sua foto para impressão. Toque em "Tentar novamente".';
      } else {
        this.erroPreviewFinal =
          "Não foi possível confirmar o envio. Gere a prévia novamente.";
      }
    },
    registrarFalhaFolha(error) {
      const detalhes = error.detalhes || {};
      const falha = montarFalhaFoto({
        tipo: error.tipo,
        indices: detalhes.indices || [],
        tentativas: detalhes.tentativas || null,
        causa: detalhes.causa || null,
        causas: detalhes.causas || [],
      });
      posthog.capture("editor_sheet_failure", {
        failure_type: falha.tipo,
        photos: falha.fotos,
        attempts: falha.tentativas,
        cause: falha.causa,
        photo_type: this.tipo,
      });
      const compra = this.$store.getters["compra/getCompra"];
      // Sem await: offline o setDoc só resolve quando a conexão volta.
      registrarFalhaFoto(compra && compra.id, falha).catch((erro) =>
        console.error("Erro ao registrar falha da folha", erro)
      );
    },
    reiniciarTotem() {
      RestartTotem();
    },
    corrigirFotoDoPreview(index) {
      this.indexAtualDaFoto = index;
      this.mountView = "";
    },
    async processoFinalizar() {
      if (!(await this.validarMoldurasEventoAtuais())) return;
      if (!this.listaPreviewsFinais.length) {
        this.abrirPreviewFinal();
        return;
      }
      if (!this.exportInst.hasPreviewSyncWithCanvas(this.listaPreviewsFinais)) {
        this.erroPreviewFinal =
          "As fotos foram alteradas. Revise novamente a prévia antes de confirmar.";
        this.abrirPreviewFinal();
        return;
      }

      this.modalInterfaceLoading = true;
      this.loadingFinalizar = true;
      this.mountView = "";
      this.contadorUpload = 0;

      if (this.tipo === "polaroid") {
        // Para polaroid: 2 fotos compõem 1 folha 1300×800 para impressão
        const uploadCount = Math.ceil(this.canvas.length / 2);
        this.contadorUploadMax = uploadCount;
        this.exportInst
          .savePolaroidSheets(
            this.listaPreviewsFinais,
            uploadCount,
            (upload, max) => {
              this.contadorUpload = upload;
              if (upload >= max) {
                this.loadingFinalizar = false;
              }
            }
          )
          .catch((error) => this.falhaAoFinalizar(error));
      } else if (this.tipo === "normal") {
        // Para normal: 1 foto por folha 1774×1182 para impressão
        const uploadCount = this.canvas.length;
        this.contadorUploadMax = uploadCount;
        this.exportInst
          .saveNormalSheets(
            this.listaPreviewsFinais,
            uploadCount,
            (upload, max) => {
              this.contadorUpload = upload;
              if (upload >= max) {
                this.loadingFinalizar = false;
              }
            }
          )
          .catch((error) => this.falhaAoFinalizar(error));
      } else if (this.tipo === tiposDeFotos.FOTOS_3X4) {
        // Para 3x4: 1 foto repetida 8 vezes em grade 2×4 em folha retrato
        const uploadCount = this.canvas.length;
        this.contadorUploadMax = uploadCount;
        this.exportInst
          .save3x4Sheets(
            this.listaPreviewsFinais,
            uploadCount,
            (upload, max) => {
              this.contadorUpload = upload;
              if (upload >= max) {
                this.loadingFinalizar = false;
              }
            }
          )
          .catch((error) => this.falhaAoFinalizar(error));
      } else if (this.tipo === tiposDeFotos.PASSAPORTE) {
        // Para passaporte: 1 foto repetida 4 vezes em grade 2×2 na folha
        const uploadCount = this.canvas.length;
        this.contadorUploadMax = uploadCount;
        this.exportInst
          .savePassaporteSheets(
            this.listaPreviewsFinais,
            uploadCount,
            (upload, max) => {
              this.contadorUpload = upload;
              if (upload >= max) {
                this.loadingFinalizar = false;
              }
            }
          )
          .catch((error) => this.falhaAoFinalizar(error));
      } else {
        this.contadorUploadMax = this.canvas.length;
        this.canvas.forEach(async (can, index) => {
          try {
            await this.exportInst.salvaCanvas(
              can,
              index,
              (upload, max) => {
                this.contadorUpload = upload;
                if (upload >= max) {
                  this.loadingFinalizar = false;
                }
              },
              this.listaPreviewsFinais,
              this.contadorUploadMax
            );
          } catch (error) {
            this.falhaAoFinalizar(error);
          }
        });
      }
    },

    // ── Canvas: edição ─────────────────────────────────────────────────────────
    discartaSelect() {
      const canvasInst = this.getCanvas();
      canvasInst.discardActiveObject(this.itemSelecionado);
      this.itemSelecionado = "";
      canvasInst.renderAll();
    },
    selecionaImagemZero() {
      this.itemSelecionado = this.canvasEditorInst.selecionaImagemZero(
        this.indexAtualDaFoto
      );
    },
    centralizarImagem() {
      this.selecionaImagemZero();
      this.canvasEditorInst.centralizarImagem(
        this.indexAtualDaFoto,
        this.itemSelecionado
      );
    },
    flipImagem(direction) {
      this.selecionaImagemZero();
      this.canvasEditorInst.flipImagem(
        direction,
        this.indexAtualDaFoto,
        this.itemSelecionado
      );
    },
    rotateImagem(direction) {
      this.selecionaImagemZero();
      this.canvasEditorInst.rotateImagem(
        direction,
        this.indexAtualDaFoto,
        this.itemSelecionado
      );
    },
    criarTextoNoCanvasAtual(config) {
      this.canvasEditorInst.criarTextoNoCanvasAtual(
        config,
        this.indexAtualDaFoto
      );
    },
    criarEmojiNoCanvasAtual(item) {
      this.canvasEditorInst.criarEmojiNoCanvasAtual(
        item,
        this.indexAtualDaFoto
      );
    },
    removerItem() {
      const removed = this.canvasEditorInst.removerItem(
        this.indexAtualDaFoto,
        this.mostrarErro.bind(this)
      );
      if (removed) this.itemSelecionado = "";
    },
    removerTodosOsItemsDesseTipo(name) {
      this.canvasEditorInst.removerTodosOsItemsDesseTipo(
        name,
        this.indexAtualDaFoto
      );
    },
    deleteItemForItem(item) {
      this.canvasEditorInst.deleteItemForItem(item, this.indexAtualDaFoto);
    },
    selecionouItem() {
      this.itemSelecionado = this.canvasEditorInst.selecionouItem(
        this.indexAtualDaFoto
      );
    },
    mandaImagemParaTras() {
      this.canvasEditorInst.mandaImagemParaTras(this.indexAtualDaFoto);
    },
    resetZoom() {
      this.canvasEditorInst.resetZoom(this.indexAtualDaFoto);
    },
    async desfazerAlteracoesDoCanvasAtual() {
      if (this.toggleResetOriginal) return false;
      this.toggleResetOriginal = true;
      if (this.cropToggle) this.cancelarCropper();
      const index = this.indexAtualDaFoto;
      const fotoRef = this.listaImagens[index];
      try {
        // O canvas só é limpo depois que a foto original baixou: se não
        // baixar, a edição atual continua na tela.
        await this.canvasEditorInst.gerarFotoNoCanvasZerada(fotoRef, index);
      } catch (erro) {
        console.error("Falha ao baixar a foto para desfazer", erro);
        this.toggleResetOriginal = false;
        this.mostrarErro(
          "Não foi possível desfazer agora. Verifique a conexão e tente de novo."
        );
        return false;
      }
      try {
        const aplicada = await this.aplicarMolduraObrigatoria(index);
        if (!aplicada)
          this.mostrarErro("Não há moldura válida para esta orientação.");
        await waitForFontReady("Montserrat").catch(() => {});
      } catch (erro) {
        console.error("Falha ao reaplicar a moldura ao desfazer", erro);
      } finally {
        this.toggleResetOriginal = false;
      }
      return true;
    },

    // ── Filtros ────────────────────────────────────────────────────────────────
    iniciaFiltro(name, ignoreRemove) {
      this.selecionaImagemZero();
      this.filtersInst.include.brilho = this.include.brilho;
      this.filtersInst.include.contraste = this.include.contraste;
      this.filtersInst.includeOutput.brilho = this.includeOutput.brilho;
      this.filtersInst.includeOutput.contraste = this.includeOutput.contraste;
      this.filtersInst.iniciaFiltro(
        name,
        ignoreRemove,
        this.itemSelecionado,
        () => {
          this.getCanvas().renderAll();
        }
      );
    },
    apagarFiltrosExistentes() {
      this.selecionaImagemZero();
      this.filtersInst.apagarFiltrosExistentes(this.itemSelecionado, () => {
        this.getCanvas().renderAll();
      });
    },
    sumOrMinusBrilhance(method) {
      this.filtersInst.sumOrMinusBrilhance(method);
      this.include.brilho = this.filtersInst.include.brilho;
    },
    sumOrMinusContrast(method) {
      this.filtersInst.sumOrMinusContrast(method);
      this.include.contraste = this.filtersInst.include.contraste;
    },

    // ── Cropper (lógica de corte — mantida no componente pois usa fabric diretamente) ─
    initCropper() {
      const canvas = this.getCanvas();
      this.cropToggle = true;
      this.cropRect = new fabric.Rect({
        fill: "rgba(0,0,0,0.3)",
        originX: "left",
        originY: "top",
        stroke: "black",
        opacity: 1,
        width: this.canvasSize.width / 2,
        height: this.canvasSize.height / 2,
        hasRotatingPoint: false,
        // O recorte é um retângulo reto: girar não teria efeito no corte.
        lockRotation: true,
        transparentCorners: false,
        cornerColor: "white",
        cornerStrokeColor: "black",
        borderColor: "black",
        absolutePositioned: true,
        uiCut: "objetoCorte",
      });
      this.cropRect.scaleToHeight(300);
      canvas.discardActiveObject();
      canvas.centerObject(this.cropRect);
      this.cropRect.visible = true;
      this.cropRect.setControlsVisibility({ mtr: false });
      canvas.add(this.cropRect);
      canvas.setActiveObject(this.cropRect);
    },
    cancelarCropper() {
      const canvas = this.getCanvas();
      canvas.getObjects().forEach((item) => {
        if (item.uiCut == "objetoCorte") {
          canvas.remove(item);
          canvas.discardActiveObject();
        }
      });
      this.cropRect = "";
      this.cropToggle = false;
      canvas.renderAll();
    },
    // Antes o corte tirava um "print" da área (foto + moldura + textos),
    // limpava o canvas e punha o print no lugar: a moldura ficava achatada na
    // imagem (e a obrigatória entrava de novo por cima), a foto perdia o tipo
    // "foto" e o "Desfazer" e a recuperação da foto deixavam de funcionar.
    // Agora o recorte vale só para a foto; moldura, textos e emojis continuam.
    cropper() {
      const canvas = this.getCanvas();
      const cropRect = this.cropRect;
      if (!cropRect) return;
      const recorte = new fabric.Rect({
        left: cropRect.left,
        top: cropRect.top,
        width: cropRect.getScaledWidth(),
        height: cropRect.getScaledHeight(),
        absolutePositioned: true,
      });
      canvas.remove(cropRect);
      canvas.discardActiveObject();
      this.cropRect = "";
      this.cropToggle = false;
      const foto = canvas
        .getObjects()
        .find((item) => item.toObject && item.toObject().tipo === "foto");
      if (foto) {
        foto.clipPath = recorte;
        foto.dirty = true;
      }
      canvas.renderAll();
    },

    // ── Seleção de foto ────────────────────────────────────────────────────────
    selecionaCanvas(index) {
      if (this.cropToggle) {
        this.mostrarErro(
          "Você não pode trocar de imagem com o recort ativo, finalize ou cancele antes."
        );
        return false;
      }
      this.indexAtualDaFoto = index;
      this.selecionaImagemZero();
      this.filtersInst.carregaInfosFiltros(this.itemSelecionado);
      this.include.brilho = this.filtersInst.include.brilho;
      this.include.contraste = this.filtersInst.include.contraste;
      this.mountView = "";
    },

    // ── Inicialização ──────────────────────────────────────────────────────────
    // Carrega as fotos da compra (tela "Importando imagens"). Tenta de novo
    // por até 120s; passado o prazo, abre o modal de erro.
    async carregarFotos() {
      this.fecharErroCarregamento();
      this.modalInterfaceLoading = true;
      try {
        await carregarFotosComPrazo({
          indices: this.indicesSemFoto(),
          resolverUrls: () => this.resolverFotosDaCompra(),
          carregarFoto: async (foto, index, opcoes) => {
            // Uma moldura que falhou pode ser tentada de novo sem duplicar
            // a foto já baixada no canvas.
            if (!this.fotosOriginaisNoCanvas[index]) {
              await this.canvasEditorInst.gerarFotoNoCanvas(
                foto,
                index,
                null,
                opcoes
              );
              this.fotosOriginaisNoCanvas[index] = true;
            }
            await this.moldurasReadyPromise;
            if (!(await this.aplicarMolduraObrigatoria(index))) {
              throw new Error("moldura_obrigatoria_indisponivel");
            }
            this.fotosNoCanvas[index] = true;
          },
        });
        this.stopChangedOrientation = false;
      } catch (erro) {
        console.error("Erro ao carregar as fotos", erro);
        this.registrarFalhaCarregamento(erro);
        this.modalInterfaceLoading = false;
        this.abrirErroCarregamento();
        return;
      }
      // Fora do try: um problema com a fonte não é falha de carregar foto.
      await Promise.resolve()
        .then(() => waitForFontReady("Montserrat"))
        .catch(() => {});
      this.modalInterfaceLoading = false;
      // O tutorial "Como ajustar sua foto" só faz sentido com as fotos já
      // no canvas: abre depois que a tela de carregando sai.
      this.mostrarPopupInstrucoes = true;
    },
    // `null` enquanto a lista de fotos da compra ainda não chegou.
    indicesSemFoto() {
      if (!this.listaReferencias.length) return null;
      return this.listaReferencias
        .map((item, index) => index)
        .filter((index) => !this.fotosNoCanvas[index]);
    },
    // Busca as fotos da compra, monta os canvas (uma vez só) e resolve os
    // endereços de download. Roda dentro do prazo de carregamento.
    async resolverFotosDaCompra() {
      // Uma tentativa que passou do tempo pode terminar depois: a seguinte
      // reaproveita a mesma em vez de montar os canvas de novo.
      if (!this.preparoDosCanvas) {
        this.preparoDosCanvas = this.prepararCanvas().catch((erro) => {
          this.preparoDosCanvas = null;
          throw erro;
        });
      }
      await this.preparoDosCanvas;
      const urls = await resolveStorageUrls(this.listaReferencias);
      this.listaImagens = urls;
      return urls;
    },
    async prepararCanvas() {
      const fotos = await getFotosByCompraId(this.getCompra.id);
      // Sem internet o Firestore não dá erro: devolve o cache, que pode estar
      // vazio. Compra na edição sempre tem foto, então lista vazia é falha (e
      // entra na tentativa e erro) — senão o editor abria sem canvas nenhum.
      if (!fotos || !fotos.length) throw new Error("lista_de_fotos_vazia");
      this.listaReferencias = fotos;
      // A orientação inicial depende das molduras obrigatórias carregadas.
      await this.moldurasReadyPromise;
      await this.$nextTick();

      // Inicializa canvasEditor (precisa das referências no DOM)
      this.canvasEditorInst = useCanvasEditor({
        formato: this.formato,
        callbacks: {
          onItemSelecionado: (index) => {
            this.itemSelecionado = this.canvasEditorInst.selecionouItem(index);
          },
          onDiscartaSelect: () => {
            this.discartaSelect();
          },
          getMolduraDefault: (index) => this.molduraPadraoDaFoto(index),
          onContextoPerdido: (index) => {
            posthog.capture("editor_canvas_context_lost", {
              photo_index: index,
              photo_type: this.tipo,
            });
          },
        },
      });
      // Sincroniza referência de canvas
      this.canvasEditorInst.criarInstanciasDoCanvas(this.listaReferencias);
      // Copia referência do array interno
      this.canvas = this.canvasEditorInst.canvas;

      // Inicializa exportHelper
      this.exportInst = useExport({
        canvas: this.canvas,
        formato: this.formato,
        changedOrientationFn: (index) => this.changedOrientation[index],
        typeIsOrientationFn: () => this.typeIsOrientation(),
        recuperarCanvas: (index, tentativa) =>
          this.canvasEditorInst.recuperarCanvas(index, tentativa),
        onExportCompleted: async () => {
          const manifesto = buildMolduraUsageManifest({
            compraId: this.getCompra.id,
            totemId: this.$store.getters["totem/getTotem"]?.id,
            tipoFoto: this.tipo,
            previews: this.listaPreviewsFinais,
            frames: this.listaMolduras,
            codigoProduto: this.getCompra.codigo_produto,
            quantidadeFotosPedido: this.getCompra.qtde_foto,
          });
          // Telemetria não atrasa o atendimento se o Firebase estiver offline.
          prepararUsoMolduras(manifesto).catch((error) => {
            console.error(
              "Não foi possível preparar a telemetria das molduras",
              error
            );
          });
          if (ehEvento(this.$store.getters["totem/getTotem"]?.tipoTotem)) {
            // The export callback is awaited before payment. qtde_foto is
            // already converted for Polaroid; the server verifies the purchase.
            await reserveQuotaBeforePayment(manifesto?.totemId, manifesto);
            if (this.$store.getters["totem/getTotem"]?.id !== manifesto?.totemId || this.getCompra.id !== manifesto?.compraId) {
              throw new Error("O atendimento mudou. Confira a compra antes de continuar.");
            }
          }
        },
      });

      this.stopChangedOrientation = true;
      this.iniciarOrientacaoDasFotos();
    },
    // Roda com os canvas montados e antes das fotos entrarem: a foto é
    // encaixada no tamanho que o canvas tem nesse momento.
    iniciarOrientacaoDasFotos() {
      // Toda foto começa em retrato — menos no evento que só cadastrou moldura
      // paisagem para este tipo: a foto não sai sem moldura, então já começa
      // deitada.
      const comecaEmPaisagem =
        this.molduraFixaAtiva && !this.moldurasEventoDe("RETRATO").length;
      const initChanOri = {};
      this.listaReferencias.forEach((item, index) => {
        initChanOri[index] = comecaEmPaisagem;
      });
      this.changedOrientation = initChanOri;
      if (comecaEmPaisagem) {
        this.listaReferencias.forEach((item, index) =>
          this.ajustarCanvasDaFoto(index)
        );
      }
      // Card que já aparece marcado: a moldura que entra aplicada na 1ª foto.
      if (this.cardsMolduraEvento.length) {
        this.imgMolduraSelecionada = this.cardsMolduraEvento[0].dados;
      }
    },
    registrarFalhaCarregamento(erro) {
      const detalhes = (erro && erro.detalhes) || {};
      const indices =
        detalhes.pendentes || this.listaReferencias.map((item, index) => index);
      const falha = montarFalhaFoto({
        tipo: "carregamento_foto",
        indices,
        tentativas: detalhes.tentativas || null,
        causa: detalhes.causa || (erro && erro.message) || null,
        causas: detalhes.causas || [],
      });
      posthog.capture("editor_photo_load_failed", {
        photos: falha.fotos,
        attempts: falha.tentativas,
        stage: detalhes.etapa || null,
        cause: falha.causa,
        photo_type: this.tipo,
      });
      const compra = this.$store.getters["compra/getCompra"];
      registrarFalhaFoto(compra && compra.id, falha).catch((erroRegistro) =>
        console.error("Erro ao registrar falha de carregamento", erroRegistro)
      );
    },
    abrirErroCarregamento(contexto = "carregamento") {
      this.pararContadorReinicio();
      if (this.destruido) return;
      this.erroCarregamento = {
        visible: true,
        segundos: SEGUNDOS_PARA_REINICIAR,
        contexto,
      };
      this.contadorReinicio = setInterval(() => {
        const segundos = this.erroCarregamento.segundos - 1;
        this.erroCarregamento = { ...this.erroCarregamento, segundos };
        if (segundos <= 0) this.reiniciarAposErroCarregamento("tempo");
      }, 1000);
    },
    fecharErroCarregamento() {
      this.pararContadorReinicio();
      this.erroCarregamento = {
        ...this.erroCarregamento,
        visible: false,
        segundos: SEGUNDOS_PARA_REINICIAR,
      };
    },
    pararContadorReinicio() {
      if (this.contadorReinicio) {
        clearInterval(this.contadorReinicio);
        this.contadorReinicio = null;
      }
    },
    tentarCarregarNovamente() {
      const { contexto } = this.erroCarregamento;
      posthog.capture("editor_photo_load_retry", {
        context: contexto,
        photo_type: this.tipo,
      });
      if (contexto === "envio") {
        // Monta e envia de novo a partir da mesma prévia (novo prazo de 120s por folha).
        this.fecharErroCarregamento();
        return this.processoFinalizar();
      }
      return this.carregarFotos();
    },
    // `motivo`: "botao" (cliente tocou) ou "tempo" (15s sem ação).
    reiniciarAposErroCarregamento(motivo) {
      this.fecharErroCarregamento();
      posthog.capture("editor_photo_load_restart", {
        reason: motivo,
        context: this.erroCarregamento.contexto,
        photo_type: this.tipo,
      });
      RestartTotem();
    },
    async initMountInterface() {
      this.tipo = this.$store.getters["compra/getCompra"].tipo_foto;

      // Inicializa composables após saber o tipo
      this.filtersInst = useFilters();

      // O canvas só espera as molduras do evento (uma leitura de documento).
      // As globais carregam por trás: antes a tela "Importando imagens"
      // esperava a URL de todas elas.
      this.moldurasReadyPromise = this.carregarMoldurasEventoDaCompra();
      this.moldurasReadyPromise.then(() => this.carregarMoldurasGlobais());

      await this.carregarFotos();
    },
  },
};
</script>

<!-- Fontes carregadas aqui para estarem disponíveis no canvas (keyboard.vue só monta ao abrir texto) -->
<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap");
@font-face {
  font-family: "Avelyn";
  src: url("/fonts/avelyn-regular/Avelyn Regular/Avelyn Regular.otf")
    format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Betrycia";
  src: url("/fonts/betrycia/Betrycia.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Rocket";
  src: url("/fonts/rocket_chicken (1)/Rocket Chicken Demo.otf")
    format("opentype");
  font-weight: normal;
  font-style: normal;
}
</style>

<style lang="scss" scoped>
.defaultBtn {
  @apply tw-bg-white tw-py-4 tw-px-4 tw-rounded-full tw-inline-flex tw-flex-row tw-justify-center tw-items-center  tw-text-2xl tw-shadow-sm;
}
.rotate-photo-grid-container > :nth-child(3):nth-last-child(1) {
  grid-column: 1 / -1;
}

.btnZera {
  @apply tw-bg-white tw-p-5 tw-px-8  tw-text-2xl tw-rounded tw-shadow tw-font-normal;
}

.containCards {
  max-height: 400px;
  margin: 10px;
  @apply tw-grid tw-grid-cols-3 tw-flex-row tw-overflow-y-auto tw-flex-wrap tw-justify-start;
}

.containCardMoldura {
  @apply tw-flex-none;

  .cardMoldura {
    width: 230px;
    margin: 4px;
    margin-bottom: 40px;

    .imagem {
      width: 230px;
      max-width: 230px;
      height: 280px;
      max-height: 280px;
      border: 10px;
      border-radius: 15px;
      border-style: solid;

      &.cardMolduraSelected {
        border-color: #8c2667;
      }
    }

    .descricao {
      color: white;
      @apply tw-p-2 tw-text-lg tw-font-bold tw-capitalize tw-break-all tw-tracking-wider;
    }
  }
}

.bgCustom {
  background: linear-gradient(180deg, #8c2667 0%, #222129 100%);
}

.menuBottom {
  @apply tw-bottom-0 tw-absolute tw-bg-black tw-bg-opacity-95 tw-w-screen tw-py-0;
}

.totemBG {
  background-size: cover;
  background-image: linear-gradient(
      180deg,
      #978fc4 0%,
      #a78ebd 34.84%,
      rgba(207, 138, 172, 0.8) 100%
    ),
    url("../../../assets/fundo.png");
}

.btnPlusMinus {
  @apply tw-w-16 tw-h-16 tw-inline-block tw-shadow-lg tw-border tw-border-solid tw-border-white tw-rounded-full tw-text-white tw-font-light tw-text-3xl tw-items-center tw-justify-center tw-mb-5;
}

.btnUI {
  @apply tw-m-4 tw-p-4 tw-rounded-md tw-text-center;
}

.fixScreen {
  height: 100vh;
  width: 100vw;
}
@keyframes pulseEffect {
  0% {
    transform: scale(1);
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
  }
  50% {
    transform: scale(1.02);
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.8);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
  }
}

.animate-pulse {
  animation: pulseEffect 1.5s infinite ease-in-out;
}
</style>
